import { render, staticRenderFns } from "./BaseVideoCard.vue?vue&type=template&id=b798d3f0&"
import script from "./BaseVideoCard.vue?vue&type=script&lang=js&"
export * from "./BaseVideoCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseVideoCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports